import { useRef } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { axiosErrorMessage } from '@api/errors';
import useSnackbar from '@hooks/useSnackbar';
import { useAppBuilderActions } from './builder/useAppBuilder';
import { builderPath } from './builder/userAppStatus';

export const useDuplicateAndOpen = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { showError } = useSnackbar();
  const { duplicate, isDuplicating } = useAppBuilderActions();
  // Every copy counts against the app limits, so a second click before the first lands is ignored.
  const inFlightRef = useRef(false);

  const duplicateAndOpen = (appKey: string) => {
    if (inFlightRef.current) return;
    inFlightRef.current = true;
    duplicate(appKey)
      .then((copy) => navigate(builderPath(copy.appKey)))
      .catch((err: unknown) =>
        showError(
          axiosErrorMessage(
            err,
            intl.formatMessage({ id: 'apps.duplicate.failed', defaultMessage: 'This app could not be copied. Try again.' }),
          ),
        ),
      )
      .finally(() => {
        inFlightRef.current = false;
      });
  };

  return { duplicateAndOpen, isDuplicating };
};
